import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  // TextField,
} from '@mui/material';
import {
  Menu as MenuIcon,
  AccountCircle,
  Logout,
  // Settings,
  // School,
  // Palette,
  // DarkMode,
  ExpandMore,
  // CalendarToday,
  // Brightness4,
  // Brightness7,
  // SettingsOutlined,
  Brightness4Outlined,
  Brightness7Outlined,
  Person,
} from '@mui/icons-material';
import { useAuth, useViewPort } from '@/hooks';
import {  ConfirmDialog } from '@/components';
import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { setCustomColors } from '@/store';
// import { RootState, AppDispatch } from '@/store/types';
import { useTheme } from '@/hooks';

interface AppBarComponentProps {
  onMobileMenuToggle: () => void;
}

export const AppBarComponent: React.FC<AppBarComponentProps> = ({
  onMobileMenuToggle,
}) => {
  const { user, logout } = useAuth();
  const { mode, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const { isMobile } = useViewPort();
  // const dispatch = useDispatch<AppDispatch>();
  // const { academicYears,} = useSelector((state: RootState) => state.academic);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = React.useState(false);

  // Load academic years when component mounts
  // useEffect(() => {
  //   if (user?.companyId && academicYears.length === 0) {
  //     dispatch(fetchAcademicYears({ companyId: user.companyId, limit: 50 }));
  //   }
  // }, [dispatch, user?.companyId, academicYears.length]);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  // const { mode, toggleTheme } = useTheme();

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleProfileMenuClose();
    setLogoutDialogOpen(true);
  };

  const handleLogoutConfirm = async () => {
    setLogoutDialogOpen(false);
    await logout();
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  const handleProfileClick = () => {
    handleProfileMenuClose();
    navigate('/profile');
  };

  // const handleColorChange = (primary: string, secondary: string) => {
  //   dispatch(setCustomColors({ primary, secondary }));
  // };

  // const handleAcademicYearChange = (academicYearId: string) => {
  //   dispatch(setSelectedAcademicYearId(academicYearId));
  // };

  const isMenuOpen = Boolean(anchorEl);
console.log(user)
  return (
    <AppBar
      position="fixed"
      sx={{
        width: '100%',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar>
        {isMobile && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={onMobileMenuToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <img
            src="/mainlogo.png"
            alt="S&S Engineering Logo"
            style={{ height: 48, marginRight: 12, objectFit: 'contain' }}
          />
          {/* <Typography variant="h6" noWrap component="div">
            S&S Engineering
          </Typography> */}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
      
          <IconButton
            size="large"
            edge="end"
            disableFocusRipple
             TouchRippleProps={{ style: { color: 'transparent' } }}
            aria-label="account of current user"
            aria-controls="profile-menu"
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
          sx={{
    display: 'flex',
    gap: 0.5,
     '&:active': {
      background: 'red', // ✅ fixed spelling
    },
    '&:hover': {
      background: 'transparent', // ✅ fixed spelling
    },
    '&:focus-visible':{
      background: 'transparent', 
      outline:'none !important'


    }
  }}
          >
            {user?.name ? (
              <Avatar
                sx={{ 
                  width: 32,
                  height: 32,
                  fontSize: '0.875rem',
                  bgcolor: 'secondary.main',
                }}
              >
                {user.name?.charAt(0).toUpperCase()}
              </Avatar>
            ) : (
              <AccountCircle />
            )}
            <ExpandMore sx={{ fontSize: '1.2rem' }} />
          </IconButton>
        </Box>

        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={handleProfileMenuClose}
          onClick={handleProfileMenuClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: 'visible',
                mt: 1.5,
                minWidth: 200,
                border: (theme) => `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.08)'}`,
                borderRadius: 2,
                backdropFilter: 'blur(8px)',
                backgroundColor: (theme) => theme.palette.mode === 'light' 
                  ? 'rgba(255, 255, 255, 0.9)' 
                  : 'rgba(0, 0, 0, 0.9)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
              },
            },
          }}
        >
          <Box sx={{ px: 2, py: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {user?.name || 'User'}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {user?.role || 'Role'}
            </Typography>
            <Typography variant="caption" color="text.secondary" noWrap>
              {user?.email || 'Email'}
            </Typography>
          </Box>
          <Divider />
          
          {/* Academic Year Selector - Mobile Only */}
          {/* {user?.companyId && isMobile && (
            <MenuItem sx={{ py: 1 }}>
              <CalendarToday sx={{ mr: 2 }} />
              <TextField
                select
                size="small"
                variant="outlined"
                value={selectedAcademicYearId || ''}
                onChange={(e) => handleAcademicYearChange(e.target.value)}
                disabled={academicYearsLoading}
                fullWidth
                placeholder="Select Academic Year"
                slotProps={{
                  select: {
                    MenuProps: {
                      PaperProps: {
                        sx: {
                          bgcolor: 'background.paper',
                          backdropFilter: 'blur(8px)',
                          // boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                        }
                      }
                    }
                  }
                }}
              >
                {academicYears?.map((year) => (
                  <MenuItem key={year._id} value={year._id}>
                    {year.name} {(year.status === 'current' || year.isCurrent) ? '': ''}
                  </MenuItem>
                ))}
              </TextField>
            </MenuItem>
          )} */}
          
          <Divider sx={{ mb:1}} />
          <MenuItem onClick={handleProfileClick}>
            <Person sx={{ mr: 2 }} />
            Profile
          </MenuItem>
          {/* <MenuItem onClick={handleProfileMenuClose}>
            <SettingsOutlined sx={{ mr: 2, }} />
            Settings
          </MenuItem> */}
          {/* <MenuItem sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Palette sx={{ mr: 2 }} />
              Theme Colors
            </Box>
            <ColorPicker onColorChange={handleColorChange} />
          </MenuItem> */}
              {/* <IconButton onClick={toggleTheme} color="inherit">
                  {mode === 'light' ? <Brightness4 /> : <Brightness7 />}
                </IconButton> */}
          <MenuItem sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={toggleTheme}>
              {mode === 'light' ? <Brightness4Outlined  sx={{ mr: 2 }}/> : <Brightness7Outlined sx={{ mr: 2 }}/>}
              {mode === 'light' ? 'Dark' : 'Light'} Mode
            </Box>
            {/* <ThemeToggle /> */}
          </MenuItem>
          <MenuItem onClick={handleLogoutClick}>
            <Logout sx={{ mr: 2 }} />
            Logout
          </MenuItem>
        </Menu>

        {/* Logout Confirmation Dialog */}
        <ConfirmDialog
          open={logoutDialogOpen}
          title="Confirm Logout"
          message="Are you sure you want to logout? You will need to login again to access your account."
          confirmText="Logout"
          cancelText="Cancel"
          onConfirm={handleLogoutConfirm}
          onCancel={handleLogoutCancel}
          severity="warning"
        />
      </Toolbar>
    </AppBar>
  );
};